import styled from 'styled-components';

export const Header = styled.header`
  height: 48px;
  background: #32404e;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    width: 1120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  img {
    height: 27px;
    width: 100px;
  }

  div {
    flex-direction: row;

    button {
      color: #f4f4f4;
      line-height: 50px;
      padding: 0 3px;
      margin: 0 0 0 15px;
      font-weight: 700;
      font-size: 1rem;
    }

    .btn-secondary {
      background-color: transparent;
      border-color: transparent;

      &:hover {
        background-color: transparent;
        border-color: transparent;
      }

      &:focus {
        background-color: transparent;
        border-color: transparent;
      }
    }
  }
`;

export const Main = styled.main`
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 20px;

  .container {
    width: 1120px;
    display: flex;
    justify-content: space-around;

    h2 {
      color: rgb(98, 199, 68);
    }
  }

  .column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const TableOfKills = styled.div`
  .container {
    width: 1120px;
    display: flex;
    justify-content: space-around;

    .spaceBetween {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }

    .yellow {
      color: #f0de00;
    }

    div {
      text-align: center;
      height: 400px;
      overflow-y: auto;
    }
  }
`;

export const Footer = styled.footer`
  background: #222f3b;
  height: 400px;

  display: flex;
  justify-content: space-around;
  margin-top: 25px;
  padding-top: 20px;

  .container {
    width: 1120px;
    display: flex;
    justify-content: space-around;
  }

  .bold {
    font-weight: 700;
  }

  .green {
    span {
      color: #62c744;
      font-weight: 700;
    }
  }

  .gray {
    span {
      color: #6b8299;
      font-weight: 700;
    }
  }
`;
